
import BaiduImageryProvider from "./BaiduImageryProvider"
import AmapMercatorTilingScheme from "./tiling-scheme/AmapMercatorTilingScheme"
import ILayer from "./ILayer"
import TilesetLayer from "./TilesetLayer"

//online
export function createImageryLayerBybaseTerrain() {
    window.baseTerrain = window.baseTerrain || {};
    let type = window.baseTerrain.type;
    let terrainProvider;
    switch (type) {
        //在线
        case "Online":
            terrainProvider = Cesium.createWorldTerrain();
            break;
        case "Offline":
            terrainProvider = createOfflineTerrainProvider(window.baseTerrain.url);
            break;
        case "none":
            terrainProvider = new Cesium.EllipsoidTerrainProvider();
            break;
        default:
            terrainProvider = new Cesium.EllipsoidTerrainProvider();
            break;
    }


    return terrainProvider;
}

export function createOfflineTerrainProvider(url) {
    var terrainProvider = new Cesium.CesiumTerrainProvider({
        url: url,
        requestVertexNormals: true
    });
    return terrainProvider;
}


export function createImageryLayerByBaseMaps(map) {

    if (window.baseMaps && window.baseMaps.length > 0) {
        window.baseMaps.forEach(element => {
            var imageryLayer = createImageryLayerByType(element);
            map.addLayer(imageryLayer, element.name, 'map');
        });
    }
}

export function createImageryLayerByType(item) {

    let imageryLayer;
    switch (item.type) {
        case "XT_zj":
            imageryLayer = createXinTuDiQiu_ZJ_MapLayer(item.show, item.offset);
            break;
        case "GuGe_YX":
            imageryLayer = createGuGe_YX_MapLayer(item.show, item.offset);
            break;
        case "HT_YX":
            imageryLayer = createHaiTuMapLayer(item.show, item.offset);
            break;
        case "Bing_YX":
            imageryLayer = createBingMapLayer(item.show, item.offset);
            break;
        case "Grid":
            imageryLayer = createGridMapLayer(item.show, item.offset);
            break;
        case "CoordMap":
            imageryLayer = createCoordMapLayer(item.show, item.offset);
            break;
        case "TDT_SL":
            imageryLayer = createTDT_SL_MapLayer(item.show, item.offset);
            break;
        case "TDT_YX":
            imageryLayer = createTDT_YX_MapLayer(item.show, item.offset);
            break;
        case "TDT_ZJ":
            imageryLayer = createTDT_ZJ_MapLayer(item.show, item.offset);
            break;
        case "ARC_YX":
            imageryLayer = createARCGISMapLayer(item.show, item.offset);
            break;
        case "ARC_ZJ":
            imageryLayer = createARCGIS_ZJ_LSMapLayer(item.show, item.offset);
            break;
        case "GD_SL":
            imageryLayer = createGD_SL_MapLayer(item.show, item.offset);
            break;
        case "GD_YX":
            imageryLayer = createGD_YX_MapLayer(item.show, item.offset);
            break;
        case "BD_YX":
            imageryLayer = createBDMapLayer(item.show, item.offset);
            break;
        case "TX_YX":
            imageryLayer = createTX_YX_MapLayer(item.show, item.offset);
            break;
        case "TX_ZJ":
            imageryLayer = createTX_ZJ_MapLayer(item.show, item.offset);
            break;
        case "Offline":
            imageryLayer = createOfflineMapLayer(item.show, item.url, item.offset);
            break;
        case "Custom":
            imageryLayer = item.createMapLayer();
            break;

        default:
            break;
    }
    return imageryLayer;
}


export function createOfflineMapLayer(show, url, offset) {
    var tilingScheme = offset ? new AmapMercatorTilingScheme() : new Cesium.WebMercatorTilingScheme();
    var provider = new Cesium.UrlTemplateImageryProvider({
        url: url,
        credit: 'China',
        tilingScheme: tilingScheme,
        //tilingScheme: new Cesium.WebMercatorTilingScheme(),
        //maximumLevel: 12,
    });

    const imageryLayer = new Cesium.ImageryLayer(provider);
    imageryLayer.show = show;
    return imageryLayer;
}


//星图地球
export function createXinTuDiQiu_ZJ_MapLayer(show) {
    var provider = new Cesium.UrlTemplateImageryProvider({
        url: "https://tiles3.geovisearth.com/base/v1/cia/{z}/{x}/{y}?token=82455ef06c72bb3a35bbb4d7d05fd9eceb96a94dc942a056b8feb0e5928ed96f",
        maximumLevel: 18,
        tilingScheme: new Cesium.WebMercatorTilingScheme(),
    });

    const imageryLayer = new Cesium.ImageryLayer(provider);
    imageryLayer.show = show;
    return imageryLayer;
}

export function createGuGe_YX_MapLayer(show, offset) {
    // var tilingScheme = offset ? new AmapMercatorTilingScheme() : new Cesium.WebMercatorTilingScheme();
    // var provider = new Cesium.UrlTemplateImageryProvider({
    //     url: "https://gac-geo.googlecnapps.cn/maps/vt?lyrs=s&gl=CN&x={x}&y={y}&z={z}",
    //     //maximumLevel: 20,
    //     tilingScheme: tilingScheme,
    // });

    // const provider = new Cesium.UrlTemplateImageryProvider({
    //     url: 'https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', // Google 卫星地图
    // });

    const provider = new Cesium.UrlTemplateImageryProvider({
        url: 'https://mt1.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}', // 's,h' 表示卫星 + 街道注记
    });

    const imageryLayer = new Cesium.ImageryLayer(provider);
    imageryLayer.show = show;
    return imageryLayer;
}


export function createTilesetLayer(show) {
    const layer = new TilesetLayer();
    layer.show = show;
    return layer;
}

//创建要素图层
export function createFeaturesLayer(show) {
    const layer = new ILayer('ILayer' + new Date().getTime());
    layer.show = show;
    return layer;
}
//http://localhost:8999/gisData/googleImg/0/0/0.jpg

export function createChinaMapLayer(show) {
    var provider = new Cesium.UrlTemplateImageryProvider({
        //url: 'http://localhost:8999/gisData/googleImg/{z}/{x}/{y}.jpg',
        url: "http://192.168.1.11:8088/maptile/{z}/{x}/{y}.jpg",
        credit: 'China',
        tilingScheme: new Cesium.WebMercatorTilingScheme(),
        //maximumLevel: 12,
    });

    const imageryLayer = new Cesium.ImageryLayer(provider);
    imageryLayer.show = show;
    return imageryLayer;
}


export function createHaiTuMapLayer(show) {
    var provider = new Cesium.UrlTemplateImageryProvider({
        url: 'https://a.tile.openstreetmap.org/{z}/{x}/{y}.png',
        credit: 'OpenSeaMap',
        tilingScheme: new Cesium.WebMercatorTilingScheme(),
        maximumLevel: 18,
    });

    const imageryLayer = new Cesium.ImageryLayer(provider);
    imageryLayer.show = show;
    return imageryLayer;
}


//创建必应在线图层
//无标记影像 Aerial,
//有英文标记影像   AerialWithLabels,
//矢量道路  Road 
//OrdnanceSurvey,
//CollinsBart
export function createBingMapLayer(show) {

    var bing = new Cesium.BingMapsImageryProvider({
        url: 'https://dev.virtualearth.net',
        key: bingKey,
        mapStyle: Cesium.BingMapsStyle.AERIAL
    });

    return bing;
    // let bing=createWorldImagery();
    // const imageryLayer = new Cesium.ImageryLayer(bing);
    // imageryLayer.show = show;
    // return imageryLayer;

}

function createWorldImagery() {
    const style = Cesium.IonWorldImageryStyle.AERIAL;
    return new Cesium.IonImageryProvider({
        assetId: style,
    });
}



//单张图片
export function createSingleTileMapLayer(show) {
    //网格线  
    var opts = {
        url: "data/night.jpg",
    }
    var layer = new Cesium.SingleTileImageryProvider(opts);
    const imageryLayer = new Cesium.ImageryLayer(layer);
    imageryLayer.show = show;
    return imageryLayer;
}

//创建地球网格线
export function createGridMapLayer(show) {
    //网格线  
    var opts = {};
    opts.cells = 2;
    opts.color = Cesium.Color.fromCssColorString('rgba(255,255,255,1)');
    opts.glowWidth = 3;
    opts.glowColor = opts.color.withAlpha(0.3);
    opts.backgroundColor = Cesium.Color.fromCssColorString('rgba(0,0,0,0)');

    var grid = new Cesium.GridImageryProvider(opts);
    const imageryLayer = new Cesium.ImageryLayer(grid);
    imageryLayer.show = show;
    return imageryLayer;
}

//地球瓦片坐标
export function createCoordMapLayer(show) {
    var opts = {};
    var grid = new Cesium.TileCoordinatesImageryProvider(opts);
    const imageryLayer = new Cesium.ImageryLayer(grid);
    imageryLayer.show = show;
    return imageryLayer;
}


//创建OSM在线图层
export function createOSMMapLayer(show) {

    const osm = new Cesium.OpenStreetMapImageryProvider({
        url: 'https://a.tile.openstreetmap.org/'
    });
    const imageryLayer = new Cesium.ImageryLayer(osm);
    imageryLayer.show = show;
    return imageryLayer;
}

//创建在线天地图-矢量
export function createTDT_SL_MapLayer(show) {

    var tdt = new Cesium.WebMapTileServiceImageryProvider({
        url: "http://t0.tianditu.com/vec_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=vec&tileMatrixSet=w&TileMatrix={TileMatrix}&TileRow={TileRow}&TileCol={TileCol}&style=default&format=tiles&tk=" + tdtKey,
        layer: "tdtBasicLayer",
        style: "default",
        format: "image/jpeg",
        tileMatrixSetID: "GoogleMapsCompatible",
        maximumLevel: 18,
    });

    const imageryLayer = new Cesium.ImageryLayer(tdt);
    imageryLayer.show = show;
    return imageryLayer;

}

//创建在线天地图-影像
export function createTDT_YX_MapLayer(show) {

    var tdt = new Cesium.WebMapTileServiceImageryProvider({
        url: "http://t0.tianditu.com/img_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=img&tileMatrixSet=w&TileMatrix={TileMatrix}&TileRow={TileRow}&TileCol={TileCol}&style=default&format=tiles&tk=" + tdtKey,
        layer: "tdtBasicLayer",
        style: "default",
        format: "image/jpeg",
        tileMatrixSetID: "GoogleMapsCompatible",
        maximumLevel: 18,
    });

    const imageryLayer = new Cesium.ImageryLayer(tdt);
    imageryLayer.show = show;
    return imageryLayer;

}

//创建在线天地图-注记
export function createTDT_ZJ_MapLayer(show) {

    // var tdt = new Cesium.WebMapTileServiceImageryProvider({
    //     url: "http://t0.tianditu.com/cia/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=cia&tileMatrixSet=w&TileMatrix={TileMatrix}&TileRow={TileRow}&TileCol={TileCol}&style=default.jpg&tk=" + tdtKey,
    //     layer: "tdtBasicLayer",
    //     style: "default",
    //     format: "image/jpeg",
    //     tileMatrixSetID: "GoogleMapsCompatible"
    // });

    // const imageryLayer = new Cesium.ImageryLayer(tdt);
    // imageryLayer.show = show;
    // return imageryLayer;

    //在线天地图影像中文标记服务(墨卡托投影)  
    var TDT_CIA_W = "http://{s}.tianditu.gov.cn/cia_w/wmts?service=wmts&request=GetTile&version=1.0.0" +
        "&LAYER=cia&tileMatrixSet=w&TileMatrix={TileMatrix}&TileRow={TileRow}&TileCol={TileCol}" +
        "&style=default.jpg&tk=" + tdtKey;

    let cia = new Cesium.WebMapTileServiceImageryProvider({   //调用影响中文注记服务
        url: TDT_CIA_W,
        layer: "cia_w",
        style: "default",
        format: "tiles",
        tileMatrixSetID: "GoogleMapsCompatible",
        subdomains: ["t0", "t1", "t2", "t3", "t4", "t5", "t6", "t7"],//天地图8个服务器
        minimumLevel: 0,
        maximumLevel: 18,
    })

    const imageryLayer = new Cesium.ImageryLayer(cia);
    imageryLayer.show = show;
    return imageryLayer;


}

//创建在线ARCGIS影像
export function createARCGISMapLayer(show) {
    var arcgis = new Cesium.ArcGisMapServerImageryProvider({
        url: "https://services.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer",
    })

    const imageryLayer = new Cesium.ImageryLayer(arcgis);
    imageryLayer.show = show;
    return imageryLayer;
}
//http://map.geoq.cn/arcgis/rest/services/ChinaOnlineStreetPurplishBlue/MapServer/tile/8/101/210
export function createARCGIS_ZJ_LSMapLayer(show) {
    var arcgis = new Cesium.UrlTemplateImageryProvider({
        url: "http://map.geoq.cn/arcgis/rest/services/ChinaOnlineStreetPurplishBlue/MapServer/tile/{z}/{y}/{x}",
        tilingScheme: new Cesium.WebMercatorTilingScheme(),
    })
    const imageryLayer = new Cesium.ImageryLayer(arcgis);
    imageryLayer.show = show;
    return imageryLayer;
}


//创建在线高德矢量地图数据图层，自带注记
export function createGD_SL_MapLayer(show) {
    var gaode = new Cesium.UrlTemplateImageryProvider({
        url: "http://webrd02.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}",
        layer: "tdtVecBasicLayer",
        style: "default",
        format: "image/png",
        tileMatrixSetID: "GoogleMapsCompatible"
    })
    const imageryLayer = new Cesium.ImageryLayer(gaode);
    imageryLayer.show = show;
    return imageryLayer;
}

//创建在线高德影像地图数据图层，自带注记
export function createGD_YX_MapLayer(show) {
    var time = new Date().getTime();
    var gaode = new Cesium.UrlTemplateImageryProvider({
        url: 'https://webst0{s}.is.autonavi.com/appmaptile?style=6&x={x}&y={y}&z={z}',
        subdomains: ['1', '2', '3', '4'],
        maximumLevel: 18
    })
    const imageryLayer = new Cesium.ImageryLayer(gaode);
    imageryLayer.show = show;
    return imageryLayer;
}


export function createTX_YX_MapLayer(show) {
    //https://rt0.map.gtimg.com/tile?z=14&x=13526&y=9724&styleid=4&scene=0
    //https://rt1.map.gtimg.com/tile?z=17&x=108240&y=77768&styleid=4&scene=0

    var tx_anse = new Cesium.UrlTemplateImageryProvider(
        // {
        //     url: 'https://rt1.map.gtimg.com/tile?z={z}&x={x}&y={y}&styleid=4&scene=0',
        // }

        {
            url: "https://rt3.map.gtimg.com/tile?z={z}&x={x}&y={reverseY}&styleid=4&scene=0",
            customTags: {
                sx: function (imageryProvider, x, y, level) {
                    return x >> 4;
                },
                sy: function (imageryProvider, x, y, level) {
                    return ((1 << level) - y) >> 4
                }
            }
        }
        // 矢量图
        // url: "https://rt3.map.gtimg.com/tile?z={z}&x={x}&y={reverseY}&styleid=1&version=297",
        // 黑色风格
        // url: "https://rt3.map.gtimg.com/tile?z={z}&x={x}&y={reverseY}&styleid=4&scene=0",
        // 注记图1
        // url: "https://rt3.map.gtimg.com/tile?z={z}&x={x}&y={reverseY}&styleid=3&scene=0",
        // 注记图2
        // url: "https://rt3.map.gtimg.com/tile?z={z}&x={x}&y={reverseY}&styleid=2&version=297",

    )
    const imageryLayer = new Cesium.ImageryLayer(tx_anse);
    imageryLayer.show = show;
    return imageryLayer;
}


export function createTX_ZJ_MapLayer(show) {
    var tx_anse = new Cesium.UrlTemplateImageryProvider(
        {
            url: "https://rt3.map.gtimg.com/tile?z={z}&x={x}&y={reverseY}&styleid=2&version=297",
            customTags: {
                sx: function (imageryProvider, x, y, level) {
                    return x >> 4;
                },
                sy: function (imageryProvider, x, y, level) {
                    return ((1 << level) - y) >> 4
                }
            }
        }
        // 矢量图
        // url: "https://rt3.map.gtimg.com/tile?z={z}&x={x}&y={reverseY}&styleid=1&version=297",
        // 黑色风格
        // url: "https://rt3.map.gtimg.com/tile?z={z}&x={x}&y={reverseY}&styleid=4&scene=0",
        // 注记图1
        // url: "https://rt3.map.gtimg.com/tile?z={z}&x={x}&y={reverseY}&styleid=3&scene=0",
        // 注记图2
        // url: "https://rt3.map.gtimg.com/tile?z={z}&x={x}&y={reverseY}&styleid=2&version=297",

    )
    const imageryLayer = new Cesium.ImageryLayer(tx_anse);
    imageryLayer.show = show;
    return imageryLayer;
}
//创建在线百度影像地图数据图层，自带注记
export function createBDMapLayer(show) {
    var bd = new BaiduImageryProvider({ layer: 'vec' })
    const imageryLayer = new Cesium.ImageryLayer(bd);
    imageryLayer.show = show;
    return imageryLayer;
}